import { render } from "./TaxitHeader.vue?vue&type=template&id=5c194d6d"
import script from "./TaxitHeader.vue?vue&type=script&lang=js"
export * from "./TaxitHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__